import { useState, useCallback } from 'react'
import { fetchData } from '../helpers/fetchData'

const useFetchData = (isLab = false) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)

    const executeFetch = useCallback(async (method, url, payload = {}) => {
        setLoading(true)
        let result
        // if (isLab) {
        //     result = await labFetchData(method, url, payload)
        // } else {
        result = await fetchData(method, url, payload)
        // }

        result ? setData(result) : setData(null)
        setLoading(false)
        return result
    }, [])

    return { data, loading, executeFetch }
}

export default useFetchData
